import Vue from 'vue'
import Router from 'vue-router'
import About from './views/About.vue'
import TC from './views/TC.vue'
import PP from './views/PP.vue'
import AboutUs from './views/AboutUs.vue'
import Pinboard from './components/Pinboard.vue'
import MainView from './views/MainView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainView
    },
    {
      path: '/game/name/:slug',
      name: 'game-details',
      component: About,
      props: true
    },
    {
      path: '/privacy_policy',
      name: 'privacy-policy',
      component: PP,
      props: true
    },
    {
      path: '/terms&conditions',
      name: 'terms-and-conditions',
      component: TC,
      props: true
    },
    {
      path: '/about',
      name: 'about',
      component: AboutUs,
      props: true
    },
    {
      path: '/week',
      name: 'week',
      component: Pinboard,
      props: true
    }
  ]
})
